import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const ButtonContext = createContext(null);
function ButtonProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const value = props;
    return jsx(ButtonContext.Provider, { value: value, children: children });
}
function useButtonContext() {
    const context = useContext(ButtonContext);
    if (!context) {
        throw new Error("useButtonContext should be wrapped in ButtonProvider");
    }
    return context;
}

export { ButtonProvider, useButtonContext };
//# sourceMappingURL=ButtonContext.js.map
